module.exports = __webpack_public_path__ + "static/media/cq_editor_testo_sinistra b.650e0083.svg";